module.exports = __webpack_public_path__ + "static/media/GUKobe_1.0a795c4d.png";